import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DealsTracingService } from '@app/deals/services/deals-tracing.service';
import { FACET_VALUE } from '@app/new-search/constants/new-search-constants';
import { SearchService } from '@app/search/services/search.service';
import { PlatformService } from '@panamax/app-state';
import { TopSectionSearchText } from '@search/shared/models/search-page.model';
import { FEATURES } from '@shared/constants/splitio-features';
import { SearchAnalyticsService } from 'src/app/search/services/search-analytics.service';
import { NavigationHelperService } from 'src/app/shared/helpers/navigation.helpers.service';

@Component({
  selector: 'app-deals-banner',
  templateUrl: './deals-banner.component.html',
  styleUrls: ['./deals-banner.component.scss'],
})
export class DealsBannerComponent {
  @Input() textOne: string;
  @Input() textTwo: string;
  @Input() textThree: string;
  @Input() textFour: string;
  @Input() bannerStyle: string;
  @Input() buttonText: string;
  @Input() buttonLink: string[];
  @Input() observeAfterLoadedElement: string;
  @Input() isNewSearchEnabled: boolean;

  globalBlizzardDealsFlag = FEATURES.split_global_blizzard_deals.name;

  constructor(
    private router: Router,
    readonly platformService: PlatformService,
    readonly navigationHelperService: NavigationHelperService,
    readonly searchAnalyticsService: SearchAnalyticsService,
    readonly dealsTracingService: DealsTracingService,
    private readonly searchService: SearchService,
  ) {}

  goTo = (path: string[]) => {
    this.router.navigate(path);
  };

  trackWhileSuppliesLast() {
    this.searchService.goToWhileSuppliesLast();
    this.searchAnalyticsService.trackWhileSuppliesLastClick();
  }

  trackClickScoopBanner = () => {
    if (this.isNewSearchEnabled) {
      this.onSearchWithFacet(`our_exclusives:${FACET_VALUE.ALL_SCOOP}`);
    } else {
      this.onSearchWithKey(TopSectionSearchText.ALLSCOOP);
    }
    this.searchAnalyticsService.trackScoopClick();
  };

  onSearchWithFacet = (facet: string) => {
    this.navigationHelperService.routeToNewSearch({
      facetFilters: facet,
    });
  };

  onSearchWithKey = searchKey => {
    this.navigationHelperService.routeToSearch({
      searchText: searchKey,
    });
  };

  traceAllAvailableDeals = (path: string[]) => {
    this.dealsTracingService.traceAllAvailableDeals();
    this.goTo(path);
  };

  bannerOrderDealsDisplayed = () => {
    this.searchAnalyticsService.trackBannerDealsDisplayed();
  };

  bannerOrderDealsView = () => {
    this.searchAnalyticsService.trackBannerDealsView();
  };

  bannerOrderDealsClick = (path: string[]) => {
    this.goTo(path);
    this.searchAnalyticsService.trackBannerDealsClick();
  };

  bargainsBannerClick = () => {
    this.onSearchWithKey(TopSectionSearchText.EQUIPMENT_AND_SUPPLIES_PROMO);
    this.searchAnalyticsService.trackBannerDealsClick();
  };
}
